import { Component, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { HumanResourceService } from 'src/app/services/human-resource.service';
import { MasterDataService } from '../../services/master-data.service';
import { OrganizationSetupService } from '../../services/organization-setup.service';
import { DiaryReportService } from '../../services/diary-report.service';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { BranchFilterService } from 'src/app/services/branch-filter.service';

@Component({
  selector: 'app-annual-salary-report',
  templateUrl: './annual-salary-report.component.html',
  styleUrls: ['./annual-salary-report.component.css']
})
export class AnnualSalaryReportComponent implements OnInit {

  selectedBranch;
  selectedRole;
  isRoleSelected: boolean;
  isEmployeeSelected: boolean;
  isPartnerSelected: boolean;
  branchList;
  selectedEmployeeName;
  employeeList;
  selectedFinancialYear;
  financialList;
  roleList;
  selectedPartner;
  partnerList;
  annualSalaryReportList = [];
  closingDateList;
  selectedFromClosing;
  selectedToClosing;
  userRole;
  accessResponse: any;

  constructor(private masterDataService: MasterDataService,
    private diaryReportService: DiaryReportService, private commonMessageService: CommonMessageService,
    private organizationSetupService: OrganizationSetupService,
    private branchFilterService: BranchFilterService) { }

  ngOnInit(): void {
    this.selectedFinancialYear = "";
    this.selectedBranch = "";
    this.selectedPartner = "";
    this.roleList = [];
    this.selectedFromClosing = "";
    this.selectedToClosing = "";
    this.userRole = localStorage.getItem('userRole');
    this.loadInitDetails();
  }

  loadInitDetails() {
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
  }

  onFinancialYearSelected() {
    this.selectedFromClosing = "";
    this.selectedToClosing = "";
    this.selectedBranch = "";
    this.roleList = [];
    this.employeeList = [];
    if (
      this.selectedFinancialYear != null &&
      this.selectedFinancialYear != undefined &&
      this.selectedFinancialYear != ''
    ) {
      // this.masterDataService.getBranch().subscribe((res) => {
      //   this.branchList = res;
      // });
      this.masterDataService.getBranch().subscribe((res) => {
        const branches = res as any[];
        const userBranchId = Number(localStorage.getItem('branchId'));

        this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
      });
    }

    if (
      this.selectedFinancialYear != null &&
      this.selectedFinancialYear != undefined &&
      this.selectedFinancialYear != ''
    ) {
      this.masterDataService
        .getClosingDatesByFinancialYear(this.selectedFinancialYear.id)
        .subscribe((res) => {
          this.closingDateList = res;
          console.log('closing date list', this.closingDateList);
        });
    }
  }

  onBranchSelected() {
    this.roleList = [];
    this.employeeList = [];
    if (
      this.selectedBranch != null &&
      this.selectedBranch != undefined &&
      this.selectedBranch != ''
    ) {
      this.masterDataService.getUserPartnersOfBranch(this.selectedBranch.id).subscribe((resp: any) => {
        console.log('partnerlist', resp);
        this.partnerList = resp;
      })
    }
  }

  onPartnerSelected() {
    this.roleList = [];
    this.employeeList = [];
    if (
      this.selectedPartner != null &&
      this.selectedPartner != undefined &&
      this.selectedPartner != ''
    ) {
      this.masterDataService.getRoles().subscribe((resp: any) => {
        console.log('role list', resp);
        resp.map((roleResp: any) => {
          if (roleResp.name == 'Article') {
            resp.splice(roleResp.id, 1);
          }
        });
        console.log('after delete article rolelist', resp);
        this.roleList = resp;
      });
    }
  }

  onRoleSelected() {
    this.employeeList = [];
    if (
      this.selectedRole != null &&
      this.selectedRole.length != 0
    ) {
      console.log('role selectedBranch', this.selectedBranch);
      var roleId = this.selectedRole.map(({ id }) => id);
      var partnerId = this.selectedPartner.map(({ id }) => id);
      console.log('role id', roleId);
      this.diaryReportService
        .getEmpByBranchRoleMultiPartnerYear(partnerId, roleId, this.selectedFinancialYear.id)
        .subscribe((resp: any) => {
          this.employeeList = resp;
          console.log('employee list', resp);
        });
    }
  }

  selectAllRole(select: NgModel, values) {
    this.selectAll(select, values, this.isRoleSelected);
    this.isRoleSelected = !this.isRoleSelected;
    this.onRoleSelected();
  }

  selectAllEmployee(select: NgModel, values) {
    this.selectAll(select, values, this.isEmployeeSelected);
    this.isEmployeeSelected = !this.isEmployeeSelected;
  }

  selectAll(select: NgModel, values, isSelected) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  selectAllPartner(select: NgModel, values) {
    this.selectedPartner = values;

    this.selectAll(select, values, this.isPartnerSelected);
    this.isPartnerSelected = !this.isPartnerSelected;
    this.onPartnerSelected();
  }


  userId;
  partnerId;
  calculateAllTotal;
  onViewReport() {
    console.log('from dates:', this.selectedFromClosing)
    console.log('to dates:', this.selectedToClosing)

    this.calculateAllTotal = 0;
    var total = 0;
    if (this.selectedFinancialYear == null ||
      this.selectedFinancialYear == undefined ||
      this.selectedFinancialYear == '' ||
      this.selectedBranch == null ||
      this.selectedBranch == undefined ||
      this.selectedBranch == '' ||
      this.selectedRole == null ||
      this.selectedRole.length == 0 ||
      this.selectedEmployeeName == null ||
      this.selectedEmployeeName.length == 0 ||
      this.selectedPartner == null ||
      this.selectedPartner == undefined ||
      this.selectedPartner == '' ||
      this.selectedFromClosing == undefined ||
      this.selectedFromClosing == '' ||
      this.selectedFromClosing == null ||
      this.selectedToClosing == undefined ||
      this.selectedToClosing == '' ||
      this.selectedToClosing == null) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please choose all the values');
      return;
    }
    this.userId = this.selectedEmployeeName.map(({ id }) => id);
    this.partnerId = this.selectedPartner.map(({ id }) => id);
    this.masterDataService.getAnnualSalaryDetails(this.selectedFinancialYear.id, this.userId, this.partnerId, this.selectedFromClosing.closingDate, this.selectedToClosing.closingDate).subscribe((resp: any) => {
      console.log('annual salary details', resp);
      this.annualSalaryReportList = resp;
      this.annualSalaryReportList.map((res: any) => {
        total = total + res.netSalary;
        this.calculateAllTotal = Math.round(total);
      })
      if (this.annualSalaryReportList.length > 0) {
        this.showExportToExcelButton = true;
      } else {
        this.commonMessageService.swalAlertWithoutIcon('', 'No Record Found.');
        this.showExportToExcelButton = false;
      }
    });
  }

  showExportToExcelButton: boolean;
  onExportToExcelReport() {
    var partnersId = this.selectedPartner.map(({ id }) => id);
    this.masterDataService.getAnnualSalaryReportExcel(this.selectedFinancialYear.id, this.userId, partnersId, this.selectedFromClosing.closingDate, this.selectedToClosing.closingDate).subscribe((resp: any) => {
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "AnnualSalaryReport.xlsx";
      link.click();
    });
  }
}
